import { type ReactNode } from 'react';

import { type AnalyticsMetadata } from '../../../shared/types/dynamicYieldCampaign';

type DyCampaignWrapperProps = {
    readonly analyticsMetadata?: AnalyticsMetadata;
    readonly children: ReactNode;
    readonly className?: string;
};

const DyCampaignWrapper = ({
    analyticsMetadata,
    children,
    className = 'dy-campaign-wrapper',
    ...props
}: DyCampaignWrapperProps) => {
    const {
        campaignId = '',
        campaignName = '',
        experienceId = '',
        experienceName = '',
        variationId = '',
        variationName = '',
    } = analyticsMetadata || {};

    return (
        <div
            className={className}
            data-dy-campaign-id={campaignId}
            data-dy-campaign-name={campaignName}
            data-dy-experience-id={experienceId}
            data-dy-experience-name={experienceName}
            data-dy-variation-id={variationId}
            data-dy-variation-name={variationName}
            {...props}
        >
            {children}
        </div>
    );
};

export { DyCampaignWrapper };
